import { Box } from "@ecco/ui/box";
import type { BoxProps } from "@ecco/ui/box";
import type { ReactNode } from "react";
import { eccoClubVerticalGradient } from "@ecco/ui/tokens/colors";

interface GradientBorderProps extends Omit<BoxProps, "children"> {
    children: ReactNode;
}

export const GradientBorder = ({ children, ...boxProps }: GradientBorderProps) => {
    return (
        <Box display="flex" gap={4} {...boxProps}>
            <Box w="7px" flexShrink={0} bg={eccoClubVerticalGradient} />
            <Box flex={1}>{children}</Box>
        </Box>
    );
};
